import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { RatingDetails } from './model/RatingDetails';
import { ITableModel } from '../table/model/tableModel';

@Component({
  selector: 'app-rating-card',
  templateUrl: './rating-card.component.html',
  styleUrls: ['./rating-card.component.scss']
})
export class RatingCardComponent implements OnInit {

  @Input() cardDetails: RatingDetails;
  @Input() fullDataObj: any;
  tableDetails: ITableModel;
  isMobileView: any;
  emptyDataMSg: any = 'Ratings Not Found';

  constructor(
    private translate: TranslateService,
    private mobileDetectionService: MobileDetectionService
  ) { 
  }

  ngOnInit() {
    console.log('cardDetails', this.cardDetails, this.cardDetails.listOfRow, this.fullDataObj)
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  getStarValues(rating: number) {
    const floorRating = Math.floor(rating || 0); // Ensure there's a fallback
    const ceilRating = Math.ceil(rating || 0); // Ensure there's a fallback
    return { floorRating, ceilRating };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

}
